export default "__VITE_ASSET__5d7069c2__"